import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/UserProfile`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export interface ResponseData {
	firstName: string;
	lastName: string;
	languageId: string;
	profilePicture: Image | null;
	userSettings: UserSettingsApi;
	apiKeys: UserApiKey[];
	isExternallyAuthenticated: boolean;
}

export type Image = {
	id: string;
	url: string;
	availableSizes: number[];
};

export type UserSettingsApi = {
	'Price.Currency'?: string;
	'Recipe.List.ValueScope': ValueScope;
	'Preferred.Nutrient.Ids'?: string;
	'User.Profile.Allergens'?: string;
};

export type UserApiKey = {
	id: string;
	displayName: string;
	expirationTime: string;
};

export enum ValueScope {
	Total = 'Total',
	Person = 'Person',
	Parts = 'Parts',
	HundredGrams = 'HundredGrams',
}
